import { Injectable } from '@angular/core';
import { portalConst } from '@app/config';
import { BehaviorSubject, Observable, take } from 'rxjs';
import { Subdivision } from '../models/subdivision';
import { ApiService, Resp } from './api.service';
import { CrudService } from './crud.service';

@Injectable({
  providedIn: 'root',
})
export class SubdivionService extends CrudService<Subdivision> {
  public closeModal$ = new BehaviorSubject<boolean>(false);

  constructor(api: ApiService) {
    super(api, `${portalConst.api.trilhas}/v1/subdivisao`);
  }

  public getSubdivision(id: number): Observable<any> {
    return this.api.get<Subdivision>(`${this.url}`, { curso_id: id });
  }

  public postSubdivision(data: any) {
    return this.api.post<Subdivision>(`${this.url}`, data);
  }

  public updateSubdivision(subdivisionId: number, data: any) {
    return this.api.put<Subdivision>(`${this.url}/${subdivisionId}`, data);
  }

  public destroySubdivision(subdivisionId: number): Observable<Resp<{ id: number; ordem: number }[]>> {
    return this.api.delete<{ id: number; ordem: number }[]>(`${this.url}/${subdivisionId}`);
  }

  public setOrder(id: number, reordenar: number): Observable<Resp<any>> {
    return this.api.put<Resp<any>>(`${this.url}/${id}/reordenar`, { reordenar }).pipe(take(1));
  }
}
